import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const emailVerified = useAuthStore((s) => s.account?.email_verified);

  if (!isAuthenticated() || !emailVerified) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
